/**********************************************************************
 ** dms Routes                                                   **
 **********************************************************************/

(function () {
  'use strict';

  angular
    .module('home')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // dms menu
      $stateProvider.state('dms', {
        url: '/dms',
        abstract: true,
        views: {
          'main': {
            template: `
              <div ui-view="dmsmain"></div>
              <div ui-view="dm2"></div>
              <div ui-view="dm3"></div>
              <div ui-view="dm4"></div>
              <div ui-view="dm5"></div>
            `
          }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('dms state entered, params: ', $state.params);
        }]
      });

      $stateProvider
        .state('dms.scansorter', {
          url: '/scansorter',
          views: {
            dmsmain: {
              component: 'filebrowser',
              bindings: {
                filemode: 'scan'
              }
            }
          },
          resolve: {
            scan: [function () {
              return 'scan';
            }],
            clientmode: [function () {
              return 'patient';
            }]
          }

        });

      $stateProvider
        .state('dms.signoff', {
          url: '/signoff',
          views: {
            dmsmain: {
              component: 'filebrowser',
              bindings: {
                filemode: 'signoff'
              }
            }
          },
          resolve: {
            signoff: [function () {
              return 'signoff';
            }],
            clientmode: [function () {
              return 'patient';
            }]
          }

        });

      $stateProvider
        .state('dms.signoffperson', {
          url: '/signoffperson/:clientid',
          views: {
            dmsmain: {
              component: 'filebrowser',
              bindings: {
                filemode: 'signoff',
                clientmode: 'clientmode',
                clientid: 'clientid'
              }
            }
          },
          resolve: {
            signoff: [function () {
              return 'signoff';
            }],
            clientmode: [function () {
              return 'patient';
            }],
            clientid: ['$stateParams', function ($stateParams) {
              return $stateParams.clientid;
            }]
          }

        });

      $stateProvider
        .state('dms.genfilebrowser', {
          url: '/genfilebrowser',
          views: {
            dm1: {
              template: `<h3>Dateiupload (nicht patientbezogene Dateien)</h3>`
            },
            dm2: {
              component: 'genfileupload',
              bindings: {
              }
            },
            dm3: {
              template: `<h3>Dateiübersicht (nicht patientbezogene Dateien)</h3>`
            },
            dm4: {
              component: 'complexfilelist',
              bindings: {
                files: 'genfiles'
              }
            }
          },
          resolve: {
            genfiles: ['File', function (File) {
              return File.$search({doccat: 'generic', active: {$ne: false}});
            }]
          }

        });

    }

// klammerfriedhof
  }
}());